import React from "react";

interface BackArrowProps extends React.SVGProps<SVGSVGElement> {
  variant?: "pagination" | "navigation";
}

export const BackArrow: React.FC<BackArrowProps> = ({
  variant = "pagination",
  width = "24px",
  height = "24px",
  ...rest
}) => {
  const paths = {
    pagination: {
      viewBox: "0 0 24 24",
      d: "M15 18L9 12L15 6",
    },
    navigation: {
      viewBox: "0 0 8 14",
      d: "M7 13L1 7L7 1",
    },
  };

  return (
    <svg
      width={width}
      height={height}
      viewBox={paths[variant].viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d={paths[variant].d}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BackArrow;
